import btn from "./btnPermission.js";

function install(Vue) {
  Vue.directive("btn", btn);
}

btn.install = install;

export default btn;
